export const classes = {
  listItem:
    'place-between px-4 py-4 mb-1 hover:bg-grey-2 dark:hover:bg-white/[0.06] rounded-xl',
  leftContent: 'place-start',
  rightContent: 'place-end',
  quantity: 'pb-0 pt-0 w-[75px] shrink-0 bg-white dark:bg-[#332e43] rounded-lg',
  details: 'mx-4 text-sm',
  name: 'font-medium text-grey-8 dark:text-mauve-1',
  price: 'font-normal text-grey-7 dark:text-mauve-2',
  total: 'mx-2 font-medium text-grey-8 dark:text-mauve-1 text-sm',
  iconButton: 'ml-2',
};
